import {createReducer} from "redux-act";
import {
	editPreDraw,
	initPreDraw,
	resetPreDraw,
	savePreDraw,
	setPreDrawActiveIndex,
	updatePreDraw,
} from "apps/DRAW_PREDICTOR/modules/actions";
import PersistStorage from "modules/utils/PersistStorage";
import {getUserUuid} from "modules";

const user = getUserUuid();

export interface IPreDrawPickQuestion {
	id: number;
	selected: number | null;
}

export interface IPreDrawPick {
	id: number;
	allPicked: boolean;
	questions: IPreDrawPickQuestion[];
}

export interface IPreDraw {
	picks: IPreDrawPick[];
	saved: boolean;
	activeIndex: number;
}

const savedPicks = JSON.parse(PersistStorage.GET(`pre-draw-${user}`) || "[]") as IPreDrawPick[];

const initial: IPreDraw = {
	picks: savedPicks,
	saved: savedPicks.length > 0,
	activeIndex: 0,
};

export const preDraw = createReducer({}, initial)
	.on(initPreDraw, (state, payload) => ({
		...state,
		picks: payload,
	}))
	.on(updatePreDraw, (state, payload) => ({
		...state,
		picks: payload,
	}))
	.on(editPreDraw, (state) => {
		PersistStorage.SET(`pre-draw-${user}`, state.picks);
		return {
			...state,
			saved: false,
		};
	})
	.on(savePreDraw, (state) => {
		PersistStorage.SET(`pre-draw-${user}`, state.picks);
		return {
			...state,
			saved: true,
		};
	})
	.on(resetPreDraw, (state) => {
		PersistStorage.REMOVE(`pre-draw-${user}`);

		return {
			...state,
			picks: state.picks.map((group) => {
				return {
					id: group.id,
					allPicked: false,
					questions: group.questions.map((question) => {
						return {
							id: question.id,
							selected: null,
						};
					}),
				};
			}),
			saved: false,
		};
	})
	.on(setPreDrawActiveIndex, (state, payload) => ({
		...state,
		activeIndex: payload,
	}));
